import { render, staticRenderFns } from "./DashboardGoalOverview.vue?vue&type=template&id=6ce94b92&"
import script from "./DashboardGoalOverview.vue?vue&type=script&lang=js&"
export * from "./DashboardGoalOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports